import useProductAvailability from './useProductAvailability';

const useSearchAvailability = () => {
  const { hasSportsbookAccess } = useProductAvailability();

  return {
    isSearchAvailable: hasSportsbookAccess,
  };
};

export default useSearchAvailability;
